import { FC, useEffect } from 'react';
import { observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { useStores } from '~/utils';
import CreditSimulationIntro from './CreditSimulationIntro';
const CreditSimulationIntroContainer: FC = () => {
  const navigate = useNavigate();
  const { creditProducts } = useStores();
  useEffect(() => {
    creditProducts.getProductLoanDetails('1');
  }, []);
  return (
    <CreditSimulationIntro
      availableLimit={creditProducts.productLoanDetails.availableLimit}
      onSubmit={() => navigate(Routes.CREDIT_SIMULATION_VALUE)}
    />
  );
};
export default observer(CreditSimulationIntroContainer);
